import { Field, WrappedFieldProps } from "redux-form";
import { Toggle } from "rsuite";
import DatePicker from "shared/components/redux-form/DatePicker";
import dayjs from "dayjs";
import Select from "shared/components/redux-form/Select";

export default function ScheduleBracketForm() {
  const formatDate = (date: Date): Date | null => (date ? date : null);
  const TIME_MIN = [
    { label: "5 min", value: 5 },
    { label: "10 min", value: 10 },
    { label: "15 min", value: 15 },
    { label: "30 min", value: 30 },
    { label: "60 min", value: 60 },
  ];

  return (
    <>
      <div className="qualifer-grid-form-100">
        <Field
          name="startTime"
          dateFormat="DD-MM-YYYY HH:mm"
          min={dayjs().subtract(1, "day").toDate()}
          component={DatePicker}
          format={formatDate}
          placeholder="Select Start Time"
          label="Start Time"
          placement="autoVerticalStart"
        />
      </div>
      <div className="qualifer-grid-form-wrapper spacing">
        <div className="toggle-button-container">
          <p>Match Check In</p>
          <Field
            name="checkinEnabled"
            type="checkbox"
            component={({ input }: WrappedFieldProps) => (
              <Toggle
                checked={!!input.value}
                onChange={(value) => input.onChange(value)}
              />
            )}
          />
        </div>

        <Field
          cleanable={true}
          searchable={false}
          name="checkInMinutes"
          component={Select}
          placeholder="Select Check In Timer"
          label="Check In Timer (In Minutes)"
          options={TIME_MIN}
        />

        <Field
          cleanable={true}
          searchable={false}
          name="gressTime"
          component={Select}
          placeholder="Select Grace Time "
          label="Grace Time (In Minutes)"
          options={TIME_MIN}
        />
      </div>
    </>
  );
}
